module.exports = __webpack_public_path__ + "a004f63d8cf851543b799fc2b6404b62.svg";